import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { LongRunningTaskModel } from "./types";

interface CompleteLongRunningTaskDialogProps {
  task: LongRunningTaskModel | null;
  isCompleting: boolean;
  title?: string;
  onClose: () => void;
  onComplete: () => Promise<void>;
}

const CompleteLongRunningTaskDialog = ({
  task,
  isCompleting,
  title = "Complete long running task?",
  onClose,
  onComplete,
}: CompleteLongRunningTaskDialogProps) => {
  return (
    <Dialog
      open={Boolean(task)}
      onClose={onClose}
      aria-labelledby="complete-long-running-task-title"
      aria-describedby="complete-long-running-task-description"
    >
      <DialogTitle id="complete-long-running-task-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="complete-long-running-task-description">
          Are you sure you want to mark <b>{task?.task?.description}</b> as
          completed?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onComplete}
          color="primary"
          variant="contained"
          disabled={isCompleting}
        >
          Complete task
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompleteLongRunningTaskDialog;
